import React from 'react';

/** A grass block with a paw print on top: any Minecraft server. */
export default function AnyServerIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      {/* Isometric block: top, left, right */}
      <path d="M12 3 20.5 7.5 12 12 3.5 7.5 12 3Z" fill={color} opacity="0.35" />
      <path d="M3.5 7.5 12 12v9l-8.5-4.5v-9Z" fill={color} opacity="0.12" />
      <path d="M20.5 7.5 12 12v9l8.5-4.5v-9Z" fill={color} opacity="0.22" />
      <path d="M12 3 20.5 7.5v9L12 21l-8.5-4.5v-9L12 3Zm0 9v9m0-9L3.5 7.5M12 12l8.5-4.5" stroke={color}
            strokeWidth="1.5" strokeLinejoin="round" />
      {/* Grass edge */}
      <path d="M3.5 9.6 5.6 10.8 7.2 10.4l1.8 1.5 1.4-.4L12 13.9m0 0 1.6-2.4 1.4.4 1.8-1.5 1.6.4 2.1-1.2"
            stroke={color} strokeWidth="1.1" strokeLinejoin="round" opacity="0.7" />
      {/* Paw on top */}
      <ellipse cx="12" cy="7.8" rx="1.5" ry="0.9" fill={color} />
      <circle cx="10.2" cy="6.4" r="0.5" fill={color} />
      <circle cx="11.4" cy="5.8" r="0.5" fill={color} />
      <circle cx="12.7" cy="5.8" r="0.5" fill={color} />
      <circle cx="13.9" cy="6.4" r="0.5" fill={color} />
    </svg>
  );
}
